import statuses from 'status/index';

export default (status, hideSuccess = true, hideError = true) => {
    if (Array.isArray(status)) {
        if (status.find(s => s === statuses.LOADING)) {
            return statuses.LOADING;
        }
        if (status.find(s => s === statuses.SAVING)) {
            return statuses.SAVING;
        }
        if (!hideSuccess && status.find(s => s === statuses.ERROR)) {
            return statuses.ERROR;
        }
        if (!hideError && status.find(s => s === statuses.SUCCESS)) {
            return statuses.SUCCESS;
        }
    } else {
        switch (status) {
        case statuses.LOADING:
            return statuses.LOADING;
        case statuses.SAVING:
            return statuses.SAVING;
        case statuses.ERROR: {
            if (!hideError) {
                return statuses.ERROR;
            }
            break;
        }
        case statuses.SUCCESS: {
            if (!hideSuccess) {
                return statuses.SUCCESS;
            }
            break;
        }
        default:
            return statuses.STANDBY;
        }
    }

    return statuses.STANDBY;
};
